(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ring-size-guide-open]');
    if (opener) {
      const guide = document.getElementById(opener.getAttribute('aria-controls'));
      if (guide && !guide.open) {
        guide.returnFocusTo = opener;
        guide.showModal();
      }
      return;
    }
    const closer = event.target.closest('[data-ring-size-guide-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches?.('.athena-ring-size-guide')) event.target.returnFocusTo?.focus();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
